import type { IeepaAnalysisEntry } from "@/types/ieepa";

export const buildCapeReportCsv = (entries: IeepaAnalysisEntry[]): string =>
  ["Entry Number", ...entries.map((e) => e.entrySummaryNumber ?? "")].join(
    "\n"
  ) + "\n";
